export const formatKebabCase = (str: string) => str.toLowerCase()
    .replace(/[(),.]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');

